module.exports = __webpack_public_path__ + "16ebfe26a0eff201cb11c2e4ca36273c.pdf";